import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ActiveHelper from '../../../components/common/activeHelper';
import { firestore } from '../../../helpers/Firebase';
import NewModel from "./components/newModel";

const Models = ({ title, selected }) => {
  const { user } = useSelector(state => state.authUser);
  const search = useSelector(state => state.settings.search) || '';

  const [loading, setLoading] = useState(true);
  const [models, setModels] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedModel, setSelectedModel] = useState(false);

  useEffect(() => {
    firestore().collection('cars_models').doc(selected).onSnapshot(snapshot => {
      let data = snapshot.data();
      let vehicles = []

      vehicles = Object.keys(data || {})?.map(c => {
        return { key: c, name: c, models: data[c] }
      })

      setModels(vehicles);
      setLoading(false);
    })
  }, [selected]);

  // Filter models based on search
  useEffect(() => {
    let modelList = models || [];

    // Apply search filter
    if (search && search.trim()) {
      const searchLower = search.toLowerCase().trim();
      modelList = modelList.filter(item => {
        return item.name && item.name.toLowerCase().includes(searchLower);
      });
    }

    setFilteredModels(modelList);
  }, [models, search]);

  // Convert to MainPage tableColumns format
  const tableColumns = useMemo(() => [
    {
      Header: "Brand",
      accessor: "name",
      type: 'label',
      formatValue: (value) => value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : '--'
    },
    {
      Header: "Models",
      accessor: "models",
      type: 'label',
      formatValue: (value) => value ? `${value.length || 0} models` : '0 models'
    }
  ], []);

  // Custom edit function to handle edit modal
  const handleEdit = useCallback((model) => {
    setSelectedModel(model);
  }, []);

  // Custom create function to handle create modal
  const handleCreate = useCallback(() => {
    setSelectedModel({ addNew: true });
  }, []);

  return (
    <Fragment>
      {loading && (
        <div className="loading" />
      )}

      {selectedModel && (
        <NewModel
          selected={selected}
          selectedBrand={selectedModel}
          dismiss={() => setSelectedModel(false)}
        />
      )}

      <ActiveHelper
        title={title}
        selected={selected}
        data={filteredModels}
        tableColumns={tableColumns}
        permenatDelete={false}
        defaultSorting="name"
        sortDirection="asc"
        renderAsModal={true}
        modalSize="lg"
        modalBackdrop="static"
        hideDefaultDeleteButton={true}
        customEditFunction={handleEdit}
        customEditTitle="Edit"
        customCreateFunction={handleCreate}
        showCreateButton={true}
        user={user}
      />
    </Fragment>
  );
};

export default Models;